export default __webpack_public_path__ + "images/Mission.v-e744dfdb41a87e1a085980b93e76a1ee.png";